module.exports = __webpack_public_path__ + "img/AL8000-1-EN.7fadd59e.jpg";